function getTitle (vm) {
  const { title } = vm.$options
  // If we have a router title
  if( vm.$route.meta.title ){
    return vm.$t( vm.$route.meta.title );
  }
  // If we have a component title
  else if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}
export default {
  created () {
    const title = getTitle(this)
    if (title) {
      document.title = title + ' — Van Wijk Uitvaartkisten'
    }
  }
}
